var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.334 6.66602H25.0007C24.0802 6.66602 23.334 7.41221 23.334 8.33268V31.666C23.334 32.5865 24.0802 33.3327 25.0007 33.3327H28.334C29.2545 33.3327 30.0007 32.5865 30.0007 31.666V8.33268C30.0007 7.41221 29.2545 6.66602 28.334 6.66602Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66602H11.6667C10.7462 6.66602 10 7.41221 10 8.33268V31.666C10 32.5865 10.7462 33.3327 11.6667 33.3327H15C15.9205 33.3327 16.6667 32.5865 16.6667 31.666V8.33268C16.6667 7.41221 15.9205 6.66602 15 6.66602Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.b9038d34fc83fec007006c11da6c469f.svg";
export { ForwardRef as ReactComponent };